import api from "./api";

export const createBattle = async (battleData) => {
  const response = await api.post("/battles", battleData);
  return response.data;
};

export const getBattle = async (battleId) => {
  const response = await api.get(`/battles/${battleId}`);
  return response.data;
};

export const getBattleHistory = async () => {
  const response = await api.get("/battles");
  return response.data;
};

export const getBattleStats = async () => {
  const response = await api.get("/battles/stats");
  return response.data;
};
